import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import ExperienceList from './ExperienceList';
import ExperienceUpdate from './ExperienceUpdate';

@inject(
    'loginStore',
    'CmsLanguageStore',
    'CmsExperienceStore'
)
@observer
class ExperiencePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.CmsExperienceStore.getAll();
        this.props.CmsLanguageStore.getActives();
    }

    componentWillUnmount() {
        this.props.CmsExperienceStore.setshowModal(false);
    }

    cancelModal = () => {
        this.props.CmsExperienceStore.setshowModal(false);
    }

    render() {
        const {
            showModal,
            modalTitle
        } = this.props.CmsExperienceStore;

        return (
            <MainContainer title='Experience Management' menukey='experiences'>
                <Modal
                    title={modalTitle}
                    visible={showModal}
                    width={800}
                    footer={null}
                    onCancel={this.cancelModal}
                    zIndex={1000}
                >
                    <ExperienceUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <ExperienceList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default ExperiencePage